module.exports = __webpack_public_path__ + "static/media/sign-icon.3cc326ef.svg";